import propTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { HeroCard, SupportEmailText } from '../../../components';
import { SUPPORT_EMAIL } from '../../../constants';
import SyncProgress from '../SyncProgress';
import * as S from './styles';

const SyncingTracking = ({ done }) => {
  const [t] = useTranslation('calendar');

  return (
    <>
      <HeroCard
        compact
        icon={<S.SpinningIcon aria-hidden="true" />}
        title={t('syncing.tracking.title')}
      >
        <Trans
          i18nKey="syncing.tracking.description"
          ns="calendar"
          components={{ strong: <strong /> }}
        />
      </HeroCard>

      <SyncProgress done={done} />

      <S.Paragraph>
        <SupportEmailText
          i18nKey="syncing.tracking.support"
          email={SUPPORT_EMAIL}
        />
      </S.Paragraph>
    </>
  );
};

SyncingTracking.propTypes = {
  done: propTypes.bool,
};

SyncingTracking.defaultProps = {
  done: false,
};

export default SyncingTracking;
